import DraftViewer from "components/DraftViewer";
import { SuccessIcon, WarningIcon } from "themes/Icon";
import AlertComp from "themes/elements/Alert";
import AvatarComp from "themes/elements/Avatar";
import ButtonComp from "themes/elements/Button";
import style from "../../details.module.scss";

function Content(props) {
  const {
    Approval,
    status,
    tabActive,
    selectedNews,
    isSchedule,
    setSchedule,
    setFormData,
    setPublish,
    formData,
  } = props;

  return (
    <>
      {(status === "approved" || tabActive === "2") &&
      Approval &&
      !selectedNews.published_date_time ? (
        /* Scheduled for publishing Alert */
        <AlertComp
          title="Scheduled for publishing"
          desc={`${
            selectedNews.scheduled_date
              ? `Scheduled for ${selectedNews.scheduled_date}     `
              : "     "
          }`}
          icon={<SuccessIcon />}
          action={
            <div className="flex justify-center align-center gap-4">
              <ButtonComp
                onClick={() => {
                  setSchedule(true);
                }}
                variant="secondary"
                height={33}
              >
                Change date
              </ButtonComp>
              <ButtonComp
                onClick={() => {
                  setFormData((prev) => ({
                    ...prev,
                    schedule_publish: false,
                  }));
                  setPublish(true);
                }}
                height={33}
              >
                Publish now
              </ButtonComp>
            </div>
          }
        />
      ) : status == "reject" ? (
        /* News Rejected Alert */
        <AlertComp
          title="News Rejected"
          desc={formData.remark ? formData.remark : null}
          type="error"
          icon={<WarningIcon />}
          closable
        />
      ) : null}
      {/* Article Image */}
      <span className={style["banner-image"]}>
        <img
          src={
            selectedNews?.banner_img
              ? selectedNews?.banner_img
              : "png/details-banner.png"
          }
          alt=""
        />
      </span>
      <div className="flex flex-column gap-1">
        {/* Article abstract title */}
        <h3 className={`abstract-title ${style["abstract-title"]}`}>
          {selectedNews?.abstract_content}
        </h3>
        <div className={`${style["news-details"]} flex align-center gap-4`}>
          <div className={`flex align-center gap-2 ${style["details-left"]}`}>
            <div className="flex align-center gap-1">
              {/* author image */}
              {selectedNews?.author &&
                (selectedNews?.author_image ? (
                  <span className={style["avatar-img"]}>
                    <img
                      src={selectedNews?.author_image}
                      alt={selectedNews?.author?.slice(0, 4)}
                    />
                  </span>
                ) : (
                  <AvatarComp blue>
                    {selectedNews?.author?.slice(0, 1).toUpperCase()}
                  </AvatarComp>
                ))}
              {selectedNews?.author && (
                /* author name */
                <h6 className={style["details-text"]}>
                  {selectedNews?.author}
                </h6>
              )}
            </div>
            {/* Seperator : dot */}
            {selectedNews?.author && (
              <span className={style["details-dot"]}></span>
            )}
            {/* date */}
            {selectedNews?.activity && (
              <h6 className={style["details-text"]}>
                {selectedNews?.activity[0]?.date}
              </h6>
            )}
          </div>
          {/* News Source */}
          {selectedNews?.source && (
            <h6 className={style["details-text"]}>
              Source - {selectedNews?.source}
            </h6>
          )}
        </div>
      </div>
      {/* Article Content */}
      <div className={`flex flex-column gap-5 ${style["draftjs"]}`}>
        <DraftViewer content={selectedNews?.message} />
      </div>
    </>
  );
}

export default Content;
